import { useEffect, useState } from "react";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import SortIcon from "../ui-icons/table/SortIcon";
import { useAppSelector } from "src/hooks/redux";
import { selectUsers } from "src/modules/users/selector";
import { EmptyList } from "../EmptyList";
import { UserAvatar } from "../ui/avatar/Avatar";
import Loading from "../Loading";

const MyTeamTable = (props: any) => {

    const { data, customLoading, setTeamEmail } = props;
    const [sortData, setSortData] = useState<any>([]);
    const users: any = useAppSelector(selectUsers);

    const [tableHeaderContent, setTableHeaderContent] = useState<any>({
        email: {
            title: "Сотрудник",
            sort: true,
            style: { width: "20%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        countActions: {
            title: "Действия",
            sort: true,
            style: { width: "8%" },
            sortDirection: 'default',
            sortType: 'number'
        },
        countAll5Why: {
            title: "5Почему (автор · участник)",
            sort: true,
            style: { width: "16%" },
            sortDirection: 'default',
            sortType: 'number'
        },
        countAllDR: {
            title: "Отчеты об отклонениях (автор · участник)",
            sort: true,
            style: { width: "26%" },
            sortDirection: 'default',
            sortType: 'number'
        },
        countN: {
            title: "Несоответствия",
            sort: true,
            style: { width: "10%" },
            sortDirection: 'default',
            sortType: 'number'
        },
        countInc: {
            title: "Инциденты",
            sort: true,
            style: { width: "10%" },
            sortDirection: 'default',
            sortType: 'number'
        },
        countCheckList: {
            title: "Задачи в чек-листе",
            sort: true,
            style: { width: "10%" },
            sortDirection: 'default',
            sortType: 'number'
        }
    });

    const sortDataHandle = (sortField: string, sortDirection: string, sortType: string) => {
        const tempTableHeaderContent = { ...tableHeaderContent };
        let tempData = [...data];
        Object.keys(tempTableHeaderContent).map((key: string) => {
            tempTableHeaderContent[key]['sortDirection'] = 'default';
        });
        if (sortDirection === 'default') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'desc';
        }
        if (sortDirection === 'desc') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'asc';
        }
        if (sortDirection === 'asc') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'default';
            setSortData([...data]);
        }
        if (sortType === 'number') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                tempData.sort((a: any, b: any) => parseFloat(a[sortField]) - parseFloat(b[sortField]));
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                tempData.sort((a: any, b: any) => parseFloat(b[sortField]) - parseFloat(a[sortField]));
            }
        }
        if (sortType === 'string') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                tempData.sort((a: any, b: any) => {
                    return a[sortField].localeCompare(b[sortField]);
                });
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                tempData.sort((a: any, b: any) => {
                    return b[sortField].localeCompare(a[sortField]);
                });
            }
        }
        if (sortType === 'date') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                const distantFuture = new Date(8640000000000000);
                tempData.sort((a: any, b: any) => {
                    let dateA = a[sortField] || distantFuture;
                    let dateB = b[sortField] || distantFuture;
                    return dateA.getTime() - dateB.getTime();
                });
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                const distantFuture = new Date(8640000000000000);
                tempData.sort((a: any, b: any) => {
                    let dateA = a[sortField] || distantFuture;
                    let dateB = b[sortField] || distantFuture;
                    return dateB.getTime() - dateA.getTime();
                });
            }
        }
        setTableHeaderContent({ ...tempTableHeaderContent });
        setSortData([...tempData]);
    }

    useEffect(() => {
        setSortData([...data]);
        const tempTableHeaderContent = { ...tableHeaderContent };
        Object.keys(tempTableHeaderContent).length > 0 && Object.keys(tempTableHeaderContent).map((key: string) => {
            tempTableHeaderContent[key]['sortDirection'] = 'default';
        });
        setTableHeaderContent({ ...tempTableHeaderContent });
    }, [data]);

    return (
        <FlexCol className="w-full">
            <FlexCol className="relative">
                <FlexCol id="owd_calendar_wrapper" className="relative pb-5 overflow-x-auto bg-white rounded-lg table-custom shadow-custom scrollbar-none scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] max-h-[calc(100vh-210px)] min-h-[170px]">
                    <FlexCol className="divide-y grow w-full">
                        {sortData.map((item: any) => (
                            <FlexCol
                                className="py-4 tablet:-mx-2 px-[16px] tablet:px-[24px] gap-[4px] cursor-pointer text-[#637381] hover:bg-[#F3F4F6]"
                                key={item.email}
                                onClick={() => setTeamEmail(item.email)}
                            >
                                <FlexCol className="break-words w-full mb-[7px]">
                                    <div className="flex items-center w-full gap-2">
                                        <UserAvatar
                                            avatar={users[item.email] && users[item.email].avatar}
                                            shortName={users[item.email] && users[item.email].shortName}
                                            displayName={users[item.email] && users[item.email].displayName}
                                            email={item.email}
                                        />
                                        <div className="flex flex-col items-start justify-center">
                                            <span className="text-[13px] text-[#111928]">
                                                {users[item.email] && users[item.email].displayName}
                                            </span>
                                            {/* <span
                                                className="text-sm text-[#637381]"
                                                dangerouslySetInnerHTML={{
                                                    __html: users[item.email] && users[item.email].jobTitle,
                                                }}
                                            /> */}
                                        </div>
                                    </div>
                                </FlexCol>
                                <FlexCol className="break-words w-full">
                                    <span className="block text-[13px] font-normal not-italic">Действия: {item.countActions}</span>
                                </FlexCol>
                                <FlexCol className="break-words w-full">
                                    <span className="block text-[13px] font-normal not-italic">5S Аудиты: {item.count5S}</span>
                                </FlexCol>
                                <FlexCol className="break-words w-full">
                                    <span className="block text-[13px] font-normal not-italic">5Почему (автор · участник): {item.count5WhyAuthor} · {item.count5WhyEditor}</span>
                                </FlexCol>
                                <FlexCol className="break-words w-full">
                                    <span className="block text-[13px] font-normal not-italic">Отчеты об отклонениях (автор · участник): {item.countDRAuthor} · {item.countDREditor}</span>
                                </FlexCol>
                                <FlexCol className="break-words w-full">
                                    <span className="block text-[13px] font-normal not-italic">Несоответствия: {item.countN}</span>
                                </FlexCol>
                                <FlexCol className="break-words w-full">
                                    <span className="block text-[13px] font-normal not-italic">Инциденты: {item.countInc}</span>
                                </FlexCol>
                                <FlexCol className="break-words w-full">
                                    <span className="block text-[13px] font-normal not-italic">Задачи в чек-листе: {item.countCheckList}</span>
                                </FlexCol>
                            </FlexCol>
                        ))}
                    </FlexCol>
                    {customLoading &&
                        <FlexCol className="justify-center items-center absolute pt-[60px] top-0 left-0 w-full h-full items-center justify-center min-h-[170px] max-h-[calc(100vh-210px)]">
                            <Loading />
                        </FlexCol>
                    }
                    {!customLoading && data.length === 0 &&
                        <FlexCol className="justify-center items-center absolute pt-[60px] top-0 left-0 w-full h-full items-center justify-center min-h-[170px] max-h-[calc(100vh-210px)]">
                            <EmptyList title="Данные не найдены" />
                        </FlexCol>
                    }
                </FlexCol>
            </FlexCol>
        </FlexCol>
    );
}

export default MyTeamTable;

export function TableHeaderColumn({ tableHeaderContent, sortDataHandle, sortField }: any) {
    return (
        <FlexCol className="select-none" style={tableHeaderContent.style}>
            <FlexRow className="gap-x-2">
                {tableHeaderContent.icon && <FlexCol>{tableHeaderContent.icon}</FlexCol>}
                <FlexCol className="font-medium whitespace-pre-line w-fit">{tableHeaderContent.title}</FlexCol>
                {tableHeaderContent.sort && (
                    <FlexCol className="w-auto cursor-pointer" onClick={() => sortDataHandle(sortField, tableHeaderContent.sortDirection, tableHeaderContent.sortType)}>
                        <SortIcon sortDirection={tableHeaderContent.sortDirection} />
                    </FlexCol>
                )}
            </FlexRow>
        </FlexCol>
    );
}
